<template>
  <div class="severity-label">
    <!-- <p class="severity-label__label">Severity:</p> -->
    <span :class="[
      'severity-label__value',
      severity === 1 ? 'severity-label__value--low' : severity === 2 ? 'severity-label__value--medium' : 'severity-label__value--high'
    ]">
      {{ $t(severity === 1 ? 'common.severity.low' : severity === 2 ? 'common.severity.medium' : 'common.severity.high') }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'SeverityLabel',
  props: {
    severity: {
      type: Number,
      required: true
    }
  }
}
</script>

<style scoped>
.severity-label {
  display: flex;
  align-items: center;
  flex-direction: column;
}
.severity-label__label {
  margin-right: 1em;
  font-weight: bold;
}
.severity-label__value {
  display: inline-block;
  padding: 6px 12px;
  border-radius: var(--radius-pill);
  font-size: 0.75rem;
  font-weight: 500;
  line-height: 1.2;
}
.severity-label__value--low {
  background-color: var(--color-severity-low);
  color: var(--color-on-severity-low); /* white on this green is only 2.1:1 */
}
.severity-label__value--medium {
  background-color: var(--color-severity-medium);
  color: var(--color-on-severity-medium); /* white on this orange is only 2.2:1 */
}
.severity-label__value--high {
  background-color: var(--color-severity-high); /* 5.4:1 with white */
  color: var(--color-on-severity-high);
}
</style>
